var map = {
	"./OIP.webp": 354,
	"./USA.png": 691,
	"./flag3.jpeg": 656,
	"./flag4.png": 648,
	"./flag5.jpeg": 766,
	"./images (3).png": 82,
	"./images (4).jpeg": 816,
	"./images (4).png": 399,
	"./images.jpeg": 779,
	"./images.png": 50,
	"./istockphoto-878587072-612x612.jpg": 357,
	"./ksa.jpg": 281,
	"./test.jpeg": 777,
	"./west.avif": 991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;